import { put } from "redux-saga/effects";
import AppsmithConsole from "utils/AppsmithConsole";
import { ActionValidationError } from "sagas/ActionExecution/errorUtils";
import { getType, Types } from "utils/TypeHelpers";
import type {
  TCloseFilePickerModalDescription,
  TShowFilePickerModalDescription,
} from "workers/Evaluation/fns/filePickerModalFns";

export function* openFilePickerModalSaga(action: TShowFilePickerModalDescription) {
  const { modalName } = action.payload;
  if (typeof modalName !== "string") {
    throw new ActionValidationError(
      "SHOW_FILE_PICKER_MODAL_BY_NAME",
      "name",
      Types.STRING,
      getType(modalName),
    );
  }
  yield put(action);
  AppsmithConsole.info({
    text: `showFilePickerModal('${modalName ?? ""}') was triggered`,
  });
}

export function* closeFilePickerModalSaga(action: TCloseFilePickerModalDescription) {
  const { modalName } = action.payload;
  if (typeof modalName !== "string") {
    throw new ActionValidationError(
      "CLOSE_FILE_PICKER_MODAL",
      "name",
      Types.STRING,
      getType(modalName),
    );
  }
  yield put(action);
  AppsmithConsole.info({
    text: `closeFilePickerModal(${modalName}) was triggered`,
  });
}
